<template>
  <v-card class="ma-2">
    <v-card-title class="d-flex flex-row align-start justify-start pa-1">      
      <v-icon class="ml-0 mr-2 pointer-move move-field" style="flex-grow:0!important" left>mdi-cursor-move</v-icon>      
      <strong>{{field.name}}</strong>
    </v-card-title>
    <v-card-text class="pt-0">
      <div class="d-flex">
        <v-text-field class="mr-2" hide-details :label="$t('Admin.Nmea.LibelleFr')" v-model="field.libelleFr"></v-text-field>
        <v-text-field class="mx-2" hide-details :label="$t('Admin.Nmea.LibelleEn')" v-model="field.libelleEn"></v-text-field>
        <v-text-field hide-details :label="$t('Admin.Nmea.Unit')" v-model="field.unit"></v-text-field>
      </div>
      <div class="d-flex pt-2" v-if="showGraphProps">
        <div style="transform: scale(0.9);transform-origin: top left;">
          <v-switch hide-details :label="$t('Admin.Nmea.CanBePlot')" v-model="field.canBePlot" />
          <v-switch hide-details :label="$t('Admin.Nmea.OnMainPlot')" v-model="field.onMainPlot" />
        </div>
        <v-text-field class="mr-2" hide-details :label="$t('Admin.Nmea.PlotGroup')" v-model="field.plotGroup"></v-text-field>
        <number-field-factor hide-details  v-if="showGraphProps" positiveOnly class="ml-2" v-model.number="field.offsetYoForPlot" :label="$t('Admin.Nmea.OffsetYoForPlot')"  />      
      </div>            
    </v-card-text>        
  </v-card>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch} from 'vue-property-decorator'
import { NmeaConfig } from '@/models/datapool/NmeaConfig'
import { NmeaConfigField } from '@/models/datapool/NmeaConfigField'


@Component({
  name: 'AdminNmeaField',
  props:{
    field:{
      type:Object,
      default:()=>new NmeaConfigField()
    },
    showGraphProps:{
      type:Boolean,
      default:true
    }
  }
})
export default class AdminNmeaField extends Vue {      
   field!:NmeaConfigField
   showGraphProps!:boolean

}

</script>